const UserFeatures = ({
    canAccessAnalytics = false,
    canAccessBilling = false,
    canAccessContacts = false,
    canAccessMainAccountSettings = false,
    canAccessMainAnalytics = false,
    canAccessMainContacts = false,
    canAccessMainMessages = false,
    canAccessMainMyProperties = false,
    canAccessMainSecuritySettings = false,
    canAccessMessages = false,
    canAccessMultiFamilyResources = false,
    canAccessUserManagement = false,
    canAddListing = false,
    canRespondToReview = false,
    canUpdateListing = false
} = {}) => ({
    canAccessAnalytics: Boolean(canAccessAnalytics),
    canAccessBilling: Boolean(canAccessBilling),
    canAccessContacts: Boolean(canAccessContacts),
    canAccessMainAccountSettings: Boolean(canAccessMainAccountSettings),
    canAccessMainAnalytics: Boolean(canAccessMainAnalytics),
    canAccessMainContacts: Boolean(canAccessMainContacts),
    canAccessMainMessages: Boolean(canAccessMainMessages),
    canAccessMainMyProperties: Boolean(canAccessMainMyProperties),
    canAccessMainSecuritySettings: Boolean(canAccessMainSecuritySettings),
    canAccessMessages: Boolean(canAccessMessages),
    canAccessMultiFamilyResources: Boolean(canAccessMultiFamilyResources),
    canAccessUserManagement: Boolean(canAccessUserManagement),
    canAddListing: Boolean(canAddListing),
    canRespondToReview: Boolean(canRespondToReview),
    canUpdateListing: Boolean(canUpdateListing)
});

const User = ({
    loggedIn = false,
    userToken = '',
    email = '',
    hasStrongAuthentication = false,
    roles = [],
    features = {}
} = {}) => {
    const userModel = {
        loggedIn: Boolean(loggedIn),
        userToken: String(userToken),
        email: String(email),
        hasStrongAuthentication: Boolean(hasStrongAuthentication),
        roles: [].concat(roles),
        features: UserFeatures(features)
    };

    return userModel;
};

export default User;
